// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__mqhCg","icon":"styles_icon__JKp3f","chevron":"styles_chevron__ENR3l"};